document.addEventListener('DOMContentLoaded', () => {
    const accordions = document.querySelectorAll('.wp-block-addweb-blocks-accordions');

    if (!accordions.length) {
        return;
    }

    let openAccordionItem = null; // Track the currently open accordion item

    /**
     * Dispatch custom event.
     *
     * @param {element} element Trigger element.
     * @param {string}  type    A string with the name of the event.
     * @param {string}  options An object with properties passed to the CustomEvent() constructor.
     */
    const dispatchEvent = (element, type, options = {}) => {
        const event = new CustomEvent(type, options);
        element.dispatchEvent(event);
    };

    /**
     * Open accordion item.
     *
     * @param {element} button Accordion item button.
     * @param {element} panel  Accordion item panel.
     */
    const open = (button, panel) => {
        const accordionItem = button.closest('.wp-block-addweb-blocks-accordion-item');
        button.setAttribute('aria-expanded', 'true');
        if (accordionItem) {
            accordionItem.classList.add('active');
        }
        openAccordionItem = button;
    };

    /**
     * Close accordion item.
     *
     * @param {element} button Accordion item button.
     * @param {element} panel  Accordion item panel.
     */
    const close = (button, panel) => {
        const accordionItem = button.closest('.wp-block-addweb-blocks-accordion-item');
        button.setAttribute('aria-expanded', 'false');
        if (accordionItem) {
            accordionItem.classList.remove('active');
        }
        openAccordionItem = null;
    };

    /**
     * Toggle accordion item.
     *
     * @param {element} button Accordion item button.
     */
    const toggle = (button) => {
        const panelId = button.getAttribute('aria-controls');
        const panel = document.getElementById(panelId);
        if (!panel) {
            // console.error(`Panel with ID "${panelId}" not found.`);
            return;
        }

        const isOpen = button.getAttribute('aria-expanded') === 'true';
        if (!isOpen) {
            if (openAccordionItem) {
                const openPanelId = openAccordionItem.getAttribute('aria-controls');
                const openPanel = document.getElementById(openPanelId);
                if (openPanel) {
                    close(openAccordionItem, openPanel);
                }
            }
            open(button, panel);
        } else {
            close(button, panel);
        }
    };

    // Example usage: attaching the toggle function to a button click event
    document.querySelectorAll('.accordion-header').forEach(button => {
        button.addEventListener('click', () => toggle(button));
    });

    /**
     * Setup accordion item.
     *
     * @param {element} accordionItem      Accordion item element.
     * @param {number}  accordionIndex     Accordion index.
     * @param {number}  accordionItemIndex Accordion item index.
     */
    const setupAccordionItem = (accordionItem, accordionIndex, accordionItemIndex) => {
        const button = accordionItem.querySelector('button[aria-expanded]');

        if (button != null) {
            button.addEventListener('click', () => {
                toggle(button);
            });

            const accordionItemId = `accordion-${accordionIndex}-item-${accordionItemIndex}`;

            // Add ids and aria attributes.
            button.setAttribute('id', `${accordionItemId}-heading`);
            button.setAttribute('aria-controls', `${accordionItemId}-panel`);
            button.setAttribute('data-id', accordionItemId);

            const parent = button.closest('.wp-block-addweb-blocks-accordion-item');
            if (parent) {
                parent.setAttribute('id', accordionItemId);

                const panel = parent.querySelector('.accordion-panel');
                if (panel) {
                    panel.setAttribute('id', `${accordionItemId}-panel`);
                    panel.setAttribute('aria-labelledby', `${accordionItemId}-heading`);
                }
            }

            dispatchEvent(accordionItem, 'accordion:init', {
                bubbles: true,
                detail: {
                    panelId: button.dataset.id,
                },
            });
        }
    };

    /**
     * Setup accordions.
     */
    accordions.forEach((accordion, accordionIndex) => {
        const accordionItems = accordion.querySelectorAll(
            '.wp-block-addweb-blocks-accordion-item .accordion-heading',
        );

        accordionItems.forEach((accordionItem, accordionItemIndex) => {
            setupAccordionItem(accordionItem, accordionIndex, accordionItemIndex);
        });
    });
});
